import React from 'react';
import { useHistory, Switch } from 'react-router-dom';
import { SecuredRoute } from 'screens';
import {
  AuditNavigationBar,
  OutsideOrganizationAuditScreen,
  OpenLinksAuditScreen,
  PersonalAccountAuditScreen,
  OutsideOwnershipAuditScreen,
} from 'screens/AuditScreens';
import { GetUserQuery } from 'services';
import { useQuery } from '@apollo/react-hooks';
import { AuthLoader } from 'screens/LoginScreen';

import styles from 'screens/AuditScreens/screens/AuditScreen/AuditScreen.module.scss';
import { AuditQueue } from 'screens/AuditScreens/screens/AuditScreen/AuditQueue';

export const AuditRouter = () => {
  const history = useHistory();

  const { data, error } = useQuery(GetUserQuery, {
    fetchPolicy: 'cache-first',
  });

  if (data === undefined) {
    return <AuthLoader />;
  }

  if (error) {
    history.push('/');
  }
  if (data && data?.me?.organization?.type !== 'work') {
    history.push('/');
  }

  return (
    <div className={styles.pageWrap}>
      <AuditNavigationBar />
      <Switch>
        <SecuredRoute exact path={'/dsa'} component={AuditQueue} />
        <SecuredRoute
          exact
          path={'/dsa/outside-organization'}
          component={OutsideOrganizationAuditScreen}
        />
        <SecuredRoute
          exact
          path={'/dsa/personal-accounts'}
          component={PersonalAccountAuditScreen}
        />
        <SecuredRoute
          exact
          path={'/dsa/outside-ownership'}
          component={OutsideOwnershipAuditScreen}
        />
        <SecuredRoute exact path={'/dsa/open-links'} component={OpenLinksAuditScreen} />
      </Switch>
    </div>
  );
};
